var nurseslounge_myDashboard_afterPopUp = {
    request:function($params){
        $.ajax({
            url: "/myDashboard/after/popUp",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                nurseslounge_myDashboard_afterPopUp.popup($data);
            }
        });
    },
    popup:function($data){
        var $modal = $("#nurseslounge-lounge-after-popup-modal");
        $modal.find('.total').html($data.data.total).promise().done(function(){
            if($data.data.total < 500){
                $modal.find('.total').hide();
                $modal.find('.dashboards').hide();
            }else{
                $modal.find('.total').show();
                $modal.find('.dashboards').show();
            }
            $modal.modal('show');
        });
    },
};
